import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h6 q-ml-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "helper" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "btn display-inline"
}
const _hoisted_4 = {
  key: 1,
  class: "q-mt-md text-center download-text additional-text"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "remove-btn" }
const _hoisted_8 = { class: "q-my-md text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Готово", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    class: "edit-dialog",
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDialog) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"min-width":"350px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row justify-between items-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('download_new')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  icon: "close",
                  flat: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-py-none q-px-xl" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", {
                class: "drop flex column items-center justify-center",
                onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
              }, [
                (!_ctx.image)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                      _createVNode(_component_vue_feather, {
                        class: "drop-image",
                        type: "image"
                      }),
                      _createElementVNode("input", {
                        type: "file",
                        name: "image",
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
                      }, null, 32)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('download_photo')), 1))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["hidden display-inline align-center", { image: true }])
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("img", {
                          width: "84",
                          height: "84",
                          src: _ctx.image,
                          alt: "",
                          class: "img"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_vue_feather, {
                            type: "x",
                            onClick: _ctx.removeFile
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_q_icon, {
                          style: {"font-size":"18px"},
                          name: "done",
                          color: "green"
                        })
                      ]),
                      _hoisted_9
                    ]))
              ], 32)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "q-mt-lg text-primary"
          }, {
            default: _withCtx(() => [
              (_ctx.image)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    disable: _ctx.loading,
                    loading: _ctx.loading,
                    "no-caps": "",
                    rounded: "",
                    color: "primary",
                    label: _ctx.$t('change'),
                    type: "submit",
                    onClick: _ctx.onSubmit
                  }, null, 8, ["disable", "loading", "label", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}